import { useSession, type SessionUser } from '@qor/web-shared';
import { Navigate, Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { scopeOf, type Scope } from '../scope';

export interface Staff {
  user: SessionUser;
  scope: Scope;
}

/** [Authorize(Roles = "Administrator")]: signed out -> /login?return=<this page>. */
export function RequireStaff() {
  const session = useSession();
  const location = useLocation();
  if (session.isPending) return null;
  const user = session.data?.user;
  if (!user)
    return <Navigate to={`/login?return=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  return <Outlet context={{ user, scope: scopeOf(session.data) } satisfies Staff} />;
}

/** Partners, Users, Audit Log, the kiosk simulator: QOR's own staff only (anyone else goes to the dashboard). */
export function RequireInternal() {
  const staff = useStaff();
  if (!staff.scope.internal) return <Navigate to="/dashboard" replace />;
  return <Outlet context={staff} />;
}

export const useStaff = () => useOutletContext<Staff>();

/** "/": the dashboard, or sign in. */
export function HomeRedirect() {
  const session = useSession();
  if (session.isPending) return null;
  return <Navigate to={session.data?.user ? '/dashboard' : '/login'} replace />;
}
